import React from 'react'
import variables from '../../../theme/variables.scss'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import GxtPills from '../../gxt-component/gxt-pills'
const GxtInfo = () => {
    return (
        <>
            <Typography className="gray-600 fs-7 fw-normal pb-2">GXT</Typography>
            <Box
                sx={{
                    border: 1,
                    borderRadius: '0.25rem',
                    borderColor: variables.lightGray1,
                    overflow: 'hidden',
                }}
            >
                <div className="mt-3 ms-3 w-100">
                    <GxtPills name="dashboard-pills" time="" consultLetterFlag={true} />
                </div>
            </Box>
        </>
    )
}

export default GxtInfo
